module.exports = __webpack_public_path__ + "static/media/graph-footer.1cc084ce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/awair/graph-footer.svg
// module id = 252
// module chunks = 0